import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";

import { UnitSharedService } from "@Unit/shared/services/unitshared.service";

import { MenuSection } from "../../Types/menu.interface";

@Component({
  selector: "uni-desktop-menu-section",
  templateUrl: "./desktop-menu-section.component.html",
  styleUrls: ["./desktop-menu-section.component.scss"],
})
export class DesktopMenuSectionComponent {
  @Input() public section: MenuSection;
  @Input() public set active(isActive: boolean) {
    this.isActive = isActive;
  }
  public isUnitPortalStyle: boolean = false;

  public isActive: boolean = false;
  @ViewChild("target") public target: ElementRef<HTMLElement>;

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() public select = new EventEmitter<MenuSection>();

  constructor(private readonly unitSharedService: UnitSharedService) {
    this.unitSharedService.isUnitPortalStyle$.subscribe((isUnit) => {
      this.isUnitPortalStyle = isUnit;
    });
  }
  public onSelectSection(section: MenuSection): void {
    this.select.emit(section);
  }
}
